export default __webpack_public_path__ + "assets/pdf/IndigeNFT_2022.ad78a059.pdf";